import { connect } from 'react-redux';

import Layout from './Layout';
import { signOut, isAuthenticated } from '../../reducers/login';
import { isLoading } from '../../reducers/app';

const mapStateToProps = state => ({
  error: state.app.error,
  isLoading: isLoading(state.app),
  isAuthenticated: isAuthenticated(state.login),
  breadcrumbs: state.app.breadcrumbs,
});

const mapDispatchToProps = dispatch => ({
  onSignOut: () => dispatch(signOut()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Layout);
